import axios from "axios";

/**
 * URL to send request
 */
const url = process.env.React_App_Api_url;
// const url = "http://localhost:5000/user";

/**
 * Request an OTP
 * @param {String} phn phone number
 * @returns {Promise}
 */
export const requestOtp = (phn) =>
  new Promise((resolve, reject) =>
    axios
      .get(`${url}/sendOTP`, {
        headers: {
          phnno: phn,
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || "Server timed out"))
  );

/**
 * Verify OTP
 * @param {String} phn phn number
 * @param {String} otp otp
 * @returns {Promise}
 */
export const verifyOtp = (phn, otp) =>
  new Promise((resolve, reject) =>
    axios
      .get(`${url}/verifyOTP`, {
        headers: {
          phnno: phn,
          otp: otp,
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || "Server timed out"))
  );

/**
 * Sign Up New User
 * @param {Object} data form data
 * @param {String} phn phn number to register
 * @returns {Promise}
 */
// export const signUp = (data, phn) =>
//   new Promise((resolve, reject) => {
//     axios
//       .post(`${url}/signUp`, data, { headers: { phn: phn } })
//       .then((res) => resolve(res.data))
//       .catch((err) => reject(err?.response?.data || "Server timed out"));
//   });

export const fetchLocation = (pin) =>
  new Promise((resolve, reject) => {
    axios
      .get(`${url}/getLocation/${pin}`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || "Server timed out"));
  });

export const addNewUser = (phn) =>
  new Promise((resolve, reject) => {
    axios
      .get(`${url}/addNewUser`, {
        headers: {
          phnno: phn,
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || "Server timed out"));
  });
